import { render } from "./EditMediaPage.vue?vue&type=template&id=ad65afe2&ts=true"
import script from "./EditMediaPage.vue?vue&type=script&lang=ts"
export * from "./EditMediaPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__